import React from "react";
import {
  SafeAreaView,
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  TextInput,
  useWindowDimensions,
  Image,
} from "react-native";
import {
  Ionicons,
  MaterialCommunityIcons,
  Feather,
} from "@expo/vector-icons";
import shieldIcon from "../../assets/shield-check.png";

const stats = [
  {
    id: 1,
    icon: <Feather name="briefcase" size={22} color="#DCE4FF" />,
    value: "148",
    label: "Importateurs\nenregistrés",
  },
  {
    id: 2,
    icon: <Feather name="globe" size={22} color="#DCE4FF" />,
    value: "130",
    label: "Exportateurs\nréférencés",
  },
  {
    id: 3,
    icon: (
      <MaterialCommunityIcons
        name="truck-outline"
        size={24}
        color="#DCE4FF"
      />
    ),
    value: "63",
    label: "Transporteurs\nréférencés",
  },
  {
    id: 4,
    icon: <MaterialCommunityIcons name="factory" size={22} color="#DCE4FF" />,
    value: "92",
    label: "produits",
  },
  {
    id: 5,
    icon: <Feather name="briefcase" size={22} color="#DCE4FF" />,
    value: "54",
    label: "Laboratoires\nenregistrés",
  },
  {
    id: 6,
    icon: <MaterialCommunityIcons name="factory" size={22} color="#DCE4FF" />,
    value: "92",
    label: "Producteurs\nvalidés",
  },
  {
    id: 7,
    icon: (
      <MaterialCommunityIcons
        name="flask-outline"
        size={23}
        color="#DCE4FF"
      />
    ),
    value: "54",
    label: "Rupports de test produits",
  },
  {
    id: 8,
    icon: <Ionicons name="shield-checkmark" size={22} color="#67B4FF" />,
    value: "7",
    label: "Organismes\nde conformité enregistrés",
  },
];

const quickRows = [
  {
    ref: "IM-TKO-00782",
    type: "Importateur",
    name: "Ets Nkembe",
    country: "Cameroun",
    flagUrl: "https://flagcdn.com/w40/cm.png",
    status: { label: "Validé", tone: "green" },
  },
  {
    ref: "EX-IDN-00275",
    type: "Exportateur",
    name: "Sunagro Exports",
    country: "Nigeria",
    flagUrl: "https://flagcdn.com/w40/ng.png",
    status: { label: "Validé", tone: "green" },
  },
  {
    ref: "TR-IDN-00254",
    type: "Transporteur",
    name: "Bting Traders",
    country: "Cameroun",
    flagUrl: "https://flagcdn.com/w40/cm.png",
    status: { label: "En attente", tone: "orange" },
  },
];

const tableRows = [
  {
    ref: "IM-TKO-00782",
    type: "Importateur",
    name: "Ets Nkembe",
    country: "Cameroun",
    flagUrl: "https://flagcdn.com/w40/cm.png",
    products: "Footwear",
    status: { label: "Validé", tone: "green" },
    action: "16.04.2028\n22:01",
  },
  {
    ref: "EX-IDN-00275",
    type: "Exportateur",
    name: "Sunagro Exports",
    country: "Nigeria",
    flagUrl: "https://flagcdn.com/w40/ng.png",
    products: "Comestibles emballés\nOutils main",
    status: { label: "Validé", tone: "green" },
    action: "16.04.2028\n22:01",
  },
  {
    ref: "TR-TKO-00781",
    type: "Transporteur",
    name: "V Ernis frères",
    country: "Togo",
    flagUrl: "https://flagcdn.com/w40/tg.png",
    products: "Plastiques ménager",
    status: { label: "Validé", tone: "green" },
    action: "09.04.2028\n12:00",
  },
  {
    ref: "PF-TKO-00978",
    type: "Transporteur",
    name: "Bârnio Titéen",
    country: "Cameroun",
    flagUrl: "https://flagcdn.com/w40/cm.png",
    products: "Carreaux céramiques",
    status: { label: "En attente", tone: "orange" },
    action: "07.04.2028\n12:00",
  },
  {
    ref: "TR-TKO-00766",
    type: "Transporteur",
    name: "Labergdarge",
    country: "Nigeria",
    flagUrl: "https://flagcdn.com/w40/ng.png",
    products: "Literie et meteles",
    status: { label: "À suspendre", tone: "red" },
    action: "19.05.2025\n12:30",
  },
  {
    ref: "PF-TKO-00622",
    type: "Exportateur",
    name: "Montola, Tis",
    country: "Cameroun",
    flagUrl: "https://flagcdn.com/w40/cm.png",
    products: "Anriacurs",
    status: { label: "Validé", tone: "green" },
    action: "07.04.2025\n12:20",
  },
  {
    ref: "PF-TKO-00875",
    type: "Producteur",
    name: "Tràcáerôt",
    country: "Togo",
    flagUrl: "https://flagcdn.com/w40/tg.png",
    products: "Footwear",
    status: { label: "À suspendre", tone: "orange" },
    action: "06.08.2025\n22:20",
  },
];

export default function ActorsRegistryPage({ onOpenProductDossier }) {
  const { width } = useWindowDimensions();
  const isMobile = width < 1100;
  const isSmall = width < 720;

  return (
    <SafeAreaView style={styles.safe}>
      <ScrollView
        style={styles.scroll}
        contentContainerStyle={[
          styles.scrollContent,
          {
            paddingHorizontal: isSmall ? 12 : 24,
            paddingTop: isSmall ? 12 : 20,
            paddingBottom: 30,
          },
        ]}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.page}>
          <TopHeader isMobile={isMobile} isSmall={isSmall} />

          <View
            style={[
              styles.titleRow,
              {
                flexDirection: isMobile ? "column" : "row",
                gap: isMobile ? 14 : 20,
              },
            ]}
          >
            <View style={{ flex: 1 }}>
              <Text style={[styles.pageTitle, { fontSize: isSmall ? 28 : 42 }]}>
                Registre des acteurs référencés
              </Text>
              <Text
                style={[styles.pageSubtitle, { fontSize: isSmall ? 16 : 19 }]}
              >
                Importateurs, exportateurs, transporteurs et producteurs validés
                pour le corridor Tiko / Idénau
              </Text>
            </View>

            <View
              style={[
                styles.topActions,
                {
                  width: isMobile ? "100%" : "auto",
                  alignSelf: isMobile ? "stretch" : "flex-start",
                },
              ]}
            >
              <FilterButton label="Tiko" />
              <FilterButton label="30 derniers jours" />
              <PrimaryButton
                label="+ Nouveau dossier à valider"
                onPress={onOpenProductDossier}
              />
            </View>
          </View>

          <View style={styles.topMetaWrap}>
            <Text style={styles.metaLine}>
              Base de reconnaissance vérifiée ·{" "}
              <Text style={styles.greenText}>Conformité pays sources</Text> ·
            </Text>
            <Text style={styles.metaLineSmall}>
              Dernière décision prise : CR-TKO-2025 00.423, 07545..
            </Text>
          </View>

          <View
            style={[
              styles.statsGrid,
              { flexDirection: isMobile ? "column" : "row" },
            ]}
          >
            <View style={styles.statsGridCol}>
              <View
                style={[
                  styles.statsRow,
                  { flexDirection: isMobile ? "column" : "row" },
                ]}
              >
                {stats.slice(0, 4).map((item) => (
                  <StatCard key={item.id} item={item} />
                ))}
              </View>

              <View
                style={[
                  styles.statsRow,
                  { flexDirection: isMobile ? "column" : "row" },
                ]}
              >
                {stats.slice(4, 8).map((item) => (
                  <StatCard key={item.id} item={item} />
                ))}
              </View>
            </View>
          </View>

          <View style={styles.recognitionStrip}>
            <Text style={styles.recognitionStripText}>
              Base de reconnaissance vérifiée ·{" "}
              <Text style={styles.greenText}></Text> ·{" "}
              <Text style={styles.greenText}></Text> ●
            </Text>
          </View>

          <Text style={styles.metaLineBottom}>
            Dernière décision prise : CR-TKO-2025 00.423, 07545.2056 MAT
          </Text>

          <View
            style={[
              styles.headerBottomBar,
              { flexDirection: isMobile ? "column" : "row" },
            ]}
          >
            <TouchableOpacity style={styles.headerBottomSelect}>
              <View style={styles.headerBottomSelectInner}>
                <Ionicons name="square-outline" size={14} color="#DCE5FF" />
                <Text style={styles.headerBottomSelectText}>Communi-cstion</Text>
              </View>
              <Ionicons name="chevron-down" size={14} color="#B7C3EA" />
            </TouchableOpacity>

            <Text style={styles.headerBottomMiddleText}>
            
            </Text>

            <TouchableOpacity style={styles.headerBottomDeleteBtn}>
              <Ionicons name="trash-outline" size={18} color="#FFFFFF" />
              <Text style={styles.headerBottomDeleteText}>Retirer dossier</Text>
            </TouchableOpacity>
          </View>

          <View style={styles.lowerSection}>
            <View
              style={[
                styles.topTablesRow,
                { flexDirection: isMobile ? "column" : "row" },
              ]}
            ></View>

            <View style={styles.fullWidthBottomTableWrap}>
              <View style={styles.tableCard}>
                <View style={styles.tableHeaderRow}>
                  <HeaderCell flex={1.3} label="Référence acteur" />
                  <HeaderCell flex={1.2} label="Type d’acteur" />
                  <HeaderCell flex={1.2} label="Nom" />
                  <HeaderCell flex={1.1} label="Pays" />
                  <HeaderCell flex={1.5} label="Produits / familles liées" />
                  <HeaderCell flex={0.9} label="Statut" />
                  <HeaderCell flex={0.9} label="Action" />
                </View>

                {tableRows.map((row, index) => (
                  <DataRow
                    key={index}
                    row={row}
                    last={index === tableRows.length - 1}
                  />
                ))}
              </View>
            </View>
          </View>

          <View style={styles.bottomFooterSection}>
            <View style={styles.bottomFooterTopLine} />

            <View
              style={[
                styles.bottomFooterRow,
                { flexDirection: isMobile ? "column" : "row" },
              ]}
            >
              <TouchableOpacity style={styles.bottomFooterLeftSelect}>
                <View style={styles.bottomFooterLeftSelectInner}>
                  <Ionicons
                    name="desktop-outline"
                    size={16}
                    color="#DCE5FF"
                  />
                  <Text style={styles.bottomFooterLeftSelectText}>
                    Portable Minutes
                  </Text>
                </View>
                <Ionicons name="chevron-down" size={14} color="#B7C3EA" />
              </TouchableOpacity>

              <Text style={styles.bottomFooterCenterText}>
                Eniporret Exrxd SP{" "}
                <Text style={styles.bottomFooterCenterTextDim}>
                  Claet hurnimhh Servil Dromrta, Proeentlal, Ska htaeGmere:
                  Cocthmtled MLeerx Sperrlet; AsseClem; Hgrrrrth, Ch OaecceID.
                </Text>
              </Text>

              <View style={styles.bottomFooterRightGroup}>
                <TouchableOpacity style={styles.bottomFooterSmallSelect}>
                  <Text style={styles.bottomFooterSmallSelectText}>Paris</Text>
                  <Ionicons name="chevron-down" size={13} color="#B7C3EA" />
                </TouchableOpacity>

                <TouchableOpacity style={styles.bottomFooterGhostButton}>
                  <Text style={styles.bottomFooterGhostButtonText}>
                    Pncevilolieur sul Rgnntrts
                  </Text>
                </TouchableOpacity>
              </View>
            </View>

            <View style={styles.bottomFooterBottomLine} />

            <View style={styles.bottomFooterCopyrightRow}>
              <Text style={styles.bottomFooterCopyrightLeft}>
                CCI Corridor Re Couloir RDC/2025
              </Text>
              <Text style={styles.bottomFooterCopyrightRight}>
                35 emeat InerCrntT© hmw US (3 con)
              </Text>
            </View>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

function TopHeader({ isMobile, isSmall }) {
  return (
    <View
      style={[
        styles.topHeader,
        {
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "center",
        },
      ]}
    >
      <View style={styles.brandWrap}>
        <View style={styles.logoBox}>
          <Image
            source={shieldIcon}
            style={styles.logoImage}
            resizeMode="contain"
          />
        </View>

        <View>
          <Text style={[styles.brandTitle, { fontSize: isSmall ? 22 : 30 }]}>
            Registre des acteurs référencés
          </Text>
          <Text style={styles.brandSub}>
            TEPORMTIEISS DFFORNITRE, YEEKENAUER - TIKO / IDÉNAU
          </Text>
        </View>
      </View>

      <View
        style={[
          styles.headerRight,
          {
            marginLeft: isMobile ? 0 : "auto",
            marginTop: isMobile ? 14 : 0,
          },
        ]}
      >
        <View style={styles.headerMenuWrap}>
          <View style={styles.navPill}>
            <Text style={styles.navPillActive}>CLD</Text>
            <Text style={styles.navPillText}>Entrée</Text>
            <Text style={styles.navPillText}>Sanctions</Text>
            <Text style={styles.navPillText}>Standards</Text>
          </View>

          <TouchableOpacity style={styles.iconSquare}>
            <Feather name="user" size={16} color="#D9E2FF" />
          </TouchableOpacity>

          <TouchableOpacity style={styles.iconSquare}>
            <Feather name="settings" size={16} color="#D9E2FF" />
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
}

function StatCard({ item }) {
  return (
    <View style={styles.statCard}>
      <View style={styles.statIconCircle}>{item.icon}</View>
      <View style={styles.statTextWrap}>
        <Text style={styles.statValue}>{item.value}</Text>
        <Text style={styles.statLabel}>{item.label}</Text>
      </View>
    </View>
  );
}

function FilterButton({ label, dark }) {
  return (
    <TouchableOpacity
      style={[styles.filterBtn, dark ? styles.filterBtnDark : null]}
    >
      <Text style={styles.filterBtnText}>{label}</Text>
      <Ionicons name="chevron-down" size={14} color="#C9D5FF" />
    </TouchableOpacity>
  );
}

function PrimaryButton({ label, onPress }) {
  return (
    <TouchableOpacity style={styles.primaryBtn} onPress={onPress}>
      <Text style={styles.primaryBtnText}>{label}</Text>
    </TouchableOpacity>
  );
}

function MiniField({ label, value, small }) {
  const hasLabel = !!label;

  return (
    <View style={[styles.miniField, small ? styles.miniFieldSmall : null]}>
      <View style={styles.miniFieldLabelSlot}>
        {hasLabel ? (
          <Text style={styles.miniFieldLabel}>{label}</Text>
        ) : (
          <Text style={styles.miniFieldLabelGhost}>.</Text>
        )}
      </View>

      <View style={styles.miniFieldInput}>
        <Text
          style={[
            styles.miniFieldValue,
            !value ? styles.miniFieldValueEmpty : null,
          ]}
          numberOfLines={1}
        >
          {value || " "}
        </Text>
        <Ionicons name="chevron-down" size={12} color="#9FB0E0" />
      </View>
    </View>
  );
}

function MiniPagerChip({ label, active }) {
  return (
    <View
      style={[
        styles.miniPagerChip,
        active ? styles.miniPagerChipActive : null,
      ]}
    >
      <Text
        style={[
          styles.miniPagerChipText,
          active ? styles.miniPagerChipTextActive : null,
        ]}
      >
        {active ? `• ${label}` : label}
      </Text>
    </View>
  );
}

function QuickTableHeader() {
  return (
    <View style={styles.quickHeaderRow}>
      <Text style={[styles.quickHeaderText, { flex: 1.2 }]}>
        Référence acteur
      </Text>
      <Text style={[styles.quickHeaderText, { flex: 1.2 }]}>
        Type d’acteur
      </Text>
      <Text style={[styles.quickHeaderText, { flex: 1.2 }]}>Nom</Text>
      <Text style={[styles.quickHeaderText, { flex: 1.1 }]}>Pays</Text>
      <Text
        style={[styles.quickHeaderText, { flex: 0.8, textAlign: "right" }]}
      >
        Statut
      </Text>
    </View>
  );
}

function QuickRow({ row, last }) {
  return (
    <View style={[styles.quickRow, last ? { borderBottomWidth: 0 } : null]}>
      <Text style={[styles.quickCell, { flex: 1.2 }]}>{row.ref}</Text>
      <Text style={[styles.quickCell, { flex: 1.2 }]}>{row.type}</Text>
      <Text style={[styles.quickCell, { flex: 1.2 }]}>{row.name}</Text>

      <View style={[styles.countryCell, { flex: 1.1 }]}>
        <Image
          source={{ uri: row.flagUrl }}
          style={styles.flagImage}
          resizeMode="cover"
        />
        <Text style={styles.countryText}>{row.country}</Text>
      </View>

      <View style={{ flex: 0.8, alignItems: "flex-end" }}>
        <StatusBadge status={row.status} />
      </View>
    </View>
  );
}

function HeaderCell({ flex, label }) {
  return (
    <View style={{ flex }}>
      <Text style={styles.tableHeaderText}>{label}</Text>
    </View>
  );
}

function DataRow({ row, last }) {
  return (
    <View style={[styles.tableDataRow, last ? { borderBottomWidth: 0 } : null]}>
      <Text style={[styles.tableCell, { flex: 1.3 }]}>{row.ref}</Text>
      <Text style={[styles.tableCell, { flex: 1.2 }]}>{row.type}</Text>
      <Text style={[styles.tableCell, { flex: 1.2 }]}>{row.name}</Text>

      <View style={[styles.countryCell, { flex: 1.1 }]}>
        <Image
          source={{ uri: row.flagUrl }}
          style={styles.flagImage}
          resizeMode="cover"
        />
        <Text style={styles.countryText}>{row.country}</Text>
      </View>

      <Text style={[styles.tableCell, { flex: 1.5 }]}>{row.products}</Text>

      <View style={{ flex: 0.9, alignItems: "flex-start" }}>
        <StatusBadge status={row.status} />
      </View>

      <Text style={[styles.tableCellSmall, { flex: 0.9 }]}>{row.action}</Text>
    </View>
  );
}

function StatusBadge({ status }) {
  const toneStyle =
    status.tone === "green"
      ? styles.badgeGreen
      : status.tone === "red"
      ? styles.badgeRed
      : styles.badgeOrange;

  return (
    <View style={[styles.statusBadge, toneStyle]}>
      <Text style={styles.statusBadgeText}>{status.label}</Text>
    </View>
  );
}

function BulletLine({ color, text }) {
  return (
    <View style={styles.bulletLine}>
      <View style={[styles.bulletDot, { backgroundColor: color }]} />
      <Text style={styles.bulletText}>{text}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  safe: {
    flex: 1,
    backgroundColor: "#091937",
  },

  scroll: {
    flex: 1,
  },

  scrollContent: {
    flexGrow: 1,
  },

  page: {
    width: "100%",
    maxWidth: 1600,
    alignSelf: "center",
  },

  topHeader: {
    justifyContent: "space-between",
    marginBottom: 26,
    paddingBottom: 18,
    borderBottomWidth: 1,
    borderBottomColor: "rgba(255,255,255,0.05)",
  },

  brandWrap: {
    flexDirection: "row",
    alignItems: "center",
  },

  logoBox: {
    width: 54,
    height: 54,
    borderRadius: 16,
    backgroundColor: "rgba(24,86,255,0.10)",
    borderWidth: 1,
    borderColor: "rgba(103,180,255,0.35)",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 14,
  },

  logoImage: {
    width: 28,
    height: 28,
  },

  brandTitle: {
    color: "#F4F7FF",
    fontWeight: "700",
  },

  brandSub: {
    color: "#8592BE",
    fontSize: 11,
    marginTop: 6,
    letterSpacing: 0.8,
    textTransform: "uppercase",
  },

  headerRight: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },

  headerMenuWrap: {
    flexDirection: "row",
    alignItems: "center",
    gap: 0,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.08)",
    backgroundColor: "rgba(255,255,255,0.025)",
    overflow: "hidden",
  },

  navPill: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 12,
    gap: 18,
  },

  navPillActive: {
    color: "#60E08D",
    fontWeight: "700",
    fontSize: 16,
  },

  navPillText: {
    color: "#D6DEFF",
    fontSize: 14,
  },

  iconSquare: {
    width: 48,
    height: 48,
    alignItems: "center",
    justifyContent: "center",
    borderLeftWidth: 1,
    borderLeftColor: "rgba(255,255,255,0.08)",
    backgroundColor: "transparent",
  },

  titleRow: {
    marginBottom: 26,
    alignItems: "flex-start",
  },

  pageTitle: {
    color: "#F3F6FF",
    fontWeight: "700",
    lineHeight: 50,
  },

  pageSubtitle: {
    color: "#AEB8DA",
    marginTop: 10,
    lineHeight: 30,
    maxWidth: 900,
  },

  topActions: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 10,
  },

  topMetaWrap: {
    alignItems: "flex-end",
    marginTop: 2,
    marginBottom: 18,
  },

  metaLine: {
    color: "#98A4CD",
    fontSize: 13,
    textAlign: "right",
    marginTop: 4,
  },

  greenText: {
    color: "#77D38E",
  },

  onlineText: {
    color: "#77D38E",
  },

  metaLineSmall: {
    color: "#7B88B4",
    fontSize: 12,
    textAlign: "right",
    marginTop: 6,
  },

  statsGrid: {
    width: "100%",
    marginBottom: 18,
  },

  statsGridCol: {
    width: "100%",
    gap: 14,
  },

  statsRow: {
    gap: 14,
    marginBottom: 0,
  },

  statCard: {
    flex: 1,
    minHeight: 142,
    backgroundColor: "rgba(255,255,255,0.045)",
    borderRadius: 18,
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.07)",
    paddingHorizontal: 22,
    paddingVertical: 20,
    flexDirection: "row",
    alignItems: "center",
  },

  statIconCircle: {
    width: 64,
    height: 64,
    borderRadius: 32,
    backgroundColor: "rgba(0,0,0,0.18)",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 18,
  },

  statTextWrap: {
    flex: 1,
  },

  statValue: {
    color: "#F6F8FF",
    fontSize: 34,
    fontWeight: "700",
  },

  statLabel: {
    color: "#D0D8F4",
    fontSize: 16,
    lineHeight: 24,
    marginTop: 4,
  },

  filterBar: {
    backgroundColor: "rgba(255,255,255,0.045)",
    borderRadius: 14,
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.07)",
    padding: 12,
    gap: 12,
    marginBottom: 16,
  },

  leftFilters: {
    flexDirection: "row",
    gap: 10,
  },

  filterBtn: {
    minHeight: 42,
    borderRadius: 10,
    paddingHorizontal: 14,
    backgroundColor: "rgba(255,255,255,0.06)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.08)",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },

  filterBtnDark: {
    backgroundColor: "rgba(255,255,255,0.025)",
  },

  filterBtnText: {
    color: "#DFE6FF",
    fontSize: 14,
    fontWeight: "500",
  },

  primaryBtn: {
    minHeight: 44,
    borderRadius: 10,
    paddingHorizontal: 18,
    backgroundColor: "#2F72FF",
    alignItems: "center",
    justifyContent: "center",
  },

  primaryBtnText: {
    color: "#FFFFFF",
    fontSize: 14,
    fontWeight: "700",
  },

  searchWrap: {
    flexDirection: "row",
    gap: 10,
    alignItems: "center",
  },

  searchInputWrap: {
    flex: 1,
    minHeight: 44,
    borderRadius: 10,
    paddingHorizontal: 14,
    backgroundColor: "rgba(255,255,255,0.03)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.08)",
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },

  searchInput: {
    flex: 1,
    color: "#E8EEFF",
    fontSize: 14,
    outlineStyle: "none",
  },

  ensureBtn: {
    minHeight: 44,
    borderRadius: 10,
    backgroundColor: "#3B7F59",
    paddingHorizontal: 14,
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    justifyContent: "center",
  },

  ensureText: {
    color: "#E9FFF0",
    fontWeight: "700",
    fontSize: 14,
  },

  lowerSection: {
    width: "100%",
  },

  topTablesRow: {
    width: "100%",
    alignItems: "flex-start",
    marginBottom: 14,
  },

  mainContentCol: {
    flex: 1,
    minWidth: 0,
  },

  sideCol: {
    width: 420,
    flexShrink: 0,
  },

  miniToolbar: {
    width: "100%",
    backgroundColor: "rgba(255,255,255,0.04)",
    borderRadius: 14,
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.07)",
    padding: 12,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 10,
    alignItems: "flex-end",
    marginBottom: 12,
  },

  miniField: {
    minWidth: 170,
    flex: 1,
  },

  miniFieldSmall: {
    maxWidth: 80,
    minWidth: 80,
    flex: 0,
  },

  miniFieldLabelSlot: {
    minHeight: 22,
    justifyContent: "flex-end",
    marginBottom: 6,
  },

  miniFieldLabel: {
    color: "#7E8BB6",
    fontSize: 11,
  },

  miniFieldLabelGhost: {
    color: "transparent",
    fontSize: 11,
  },

  miniFieldInput: {
    minHeight: 40,
    borderRadius: 10,
    backgroundColor: "rgba(255,255,255,0.025)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.08)",
    paddingHorizontal: 12,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  miniFieldValue: {
    color: "#D8E0FA",
    fontSize: 13,
    flex: 1,
    marginRight: 8,
  },

  miniFieldValueEmpty: {
    color: "#D8E0FA",
  },

  resultsStripCard: {
    width: "100%",
    minHeight: 48,
    backgroundColor: "rgba(255,255,255,0.04)",
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.07)",
    paddingHorizontal: 12,
    paddingVertical: 8,
    marginBottom: 12,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },

  resultsStripText: {
    color: "#8F9BC5",
    fontSize: 13,
  },

  resultsStripRight: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginLeft: "auto",
  },

  miniPagerChip: {
    minHeight: 32,
    paddingHorizontal: 12,
    borderRadius: 8,
    backgroundColor: "rgba(255,255,255,0.03)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.08)",
    alignItems: "center",
    justifyContent: "center",
  },

  miniPagerChipActive: {
    backgroundColor: "rgba(255,255,255,0.06)",
  },

  miniPagerChipText: {
    color: "#C4D0F6",
    fontSize: 13,
    fontWeight: "600",
  },

  miniPagerChipTextActive: {
    color: "#FFFFFF",
  },

  resultsNextBtn: {
    minHeight: 32,
    paddingHorizontal: 12,
    borderRadius: 8,
    backgroundColor: "rgba(255,255,255,0.03)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.08)",
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },

  resultsNextBtnText: {
    color: "#DCE5FF",
    fontSize: 13,
    fontWeight: "600",
  },

  quickTableCard: {
    width: "100%",
    backgroundColor: "rgba(255,255,255,0.04)",
    borderRadius: 14,
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.07)",
    overflow: "hidden",
  },

  quickHeaderRow: {
    flexDirection: "row",
    paddingHorizontal: 16,
    paddingVertical: 14,
    borderBottomWidth: 1,
    borderBottomColor: "rgba(255,255,255,0.06)",
  },

  quickHeaderText: {
    color: "#7F8BB6",
    fontSize: 12,
    fontWeight: "600",
  },

  quickRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 15,
    borderBottomWidth: 1,
    borderBottomColor: "rgba(255,255,255,0.05)",
  },

  quickCell: {
    color: "#E8EEFF",
    fontSize: 14,
    paddingRight: 10,
  },

  fullWidthBottomTableWrap: {
    width: "100%",
  },

  tableCard: {
    width: "100%",
    backgroundColor: "rgba(255,255,255,0.04)",
    borderRadius: 14,
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.07)",    overflow: "hidden",
    alignSelf: "stretch",
  },

  tableHeaderRow: {
    flexDirection: "row",
    paddingHorizontal: 16,
    paddingVertical: 14,
    borderBottomWidth: 1,
    borderBottomColor: "rgba(255,255,255,0.06)",
  },

  tableHeaderText: {
    color: "#97A5D0",
    fontSize: 12,
    fontWeight: "600",
  },

  tableDataRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 15,
    borderBottomWidth: 1,
    borderBottomColor: "rgba(255,255,255,0.05)",
  },

  tableCell: {
    color: "#E8EEFF",
    fontSize: 14,
    lineHeight: 20,
    paddingRight: 10,
  },

  tableCellSmall: {
    color: "#ABB8E0",
    fontSize: 12,
    lineHeight: 17,
  },

  countryCell: {
    flexDirection: "row",
    alignItems: "center",
    minWidth: 0,
    paddingRight: 10,
  },

  flagImage: {
    width: 22,
    height: 16,
    borderRadius: 2,
    marginRight: 8,
  },

  countryText: {
    color: "#E8EEFF",
    fontSize: 14,
    lineHeight: 20,
    flexShrink: 1,
  },

  statusBadge: {
    borderRadius: 999,
    paddingHorizontal: 12,
    paddingVertical: 6,
  },

  badgeGreen: {
    backgroundColor: "rgba(92, 180, 116, 0.20)",
    borderWidth: 1,
    borderColor: "rgba(92, 180, 116, 0.35)",
  },

  badgeOrange: {
    backgroundColor: "rgba(223, 154, 73, 0.20)",
    borderWidth: 1,
    borderColor: "rgba(223, 154, 73, 0.34)",
  },

  badgeRed: {
    backgroundColor: "rgba(217, 88, 88, 0.22)",
    borderWidth: 1,
    borderColor: "rgba(217, 88, 88, 0.38)",
  },

  statusBadgeText: {
    color: "#FFFFFF",
    fontSize: 13,
    fontWeight: "700",
  },

  summaryCard: {
    width: "100%",
    backgroundColor: "rgba(255,255,255,0.045)",
    borderRadius: 16,
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.07)",
    padding: 18,
  },

  summaryTitle: {
    color: "#F1F5FF",
    fontSize: 20,
    fontWeight: "700",
    marginBottom: 16,
  },

  bulletLine: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 16,
  },

  bulletDot: {
    width: 9,
    height: 9,
    borderRadius: 4.5,
    marginTop: 6,
    marginRight: 12,
  },

  bulletText: {
    flex: 1,
    color: "#D8E0FA",
    fontSize: 15,
    lineHeight: 22,
  },

  sideButton: {
    minHeight: 46,
    borderRadius: 10,
    paddingHorizontal: 14,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 10,
  },

  sideButtonDark: {
    backgroundColor: "rgba(255,255,255,0.04)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.08)",
  },

  sideButtonGreen: {
    backgroundColor: "#3F8D63",
  },

  sideButtonText: {
    color: "#E8EEFF",
    fontSize: 14,
    fontWeight: "600",
    flex: 1,
    marginRight: 10,
  },

  recognitionStrip: {
    width: "100%",
    minHeight: 52,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.06)",
    backgroundColor: "rgba(255,255,255,0.03)",
    justifyContent: "center",
    paddingHorizontal: 18,
    marginBottom: 12,
  },

  recognitionStripText: {
    color: "#AAB6DE",
    fontSize: 14,
  },

  metaLineBottom: {
    color: "#8E9AC5",
    fontSize: 12,
    marginBottom: 22,
  },

  headerBottomBar: {
    width: "100%",
    alignItems: "center",
    gap: 16,
    paddingTop: 16,
    paddingBottom: 18,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(120,138,196,0.18)",
    marginBottom: 18,
  },

  headerBottomSelect: {
    minHeight: 42,
    minWidth: 210,
    paddingHorizontal: 14,
    borderRadius: 10,
    backgroundColor: "rgba(255,255,255,0.04)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.08)",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  headerBottomSelectInner: {
    flexDirection: "row",
    alignItems: "center",
  },

  headerBottomSelectText: {
    color: "#E5ECFF",
    fontSize: 14,
    fontWeight: "500",
    marginLeft: 10,
  },

  headerBottomMiddleText: {
    flex: 1,
    color: "#C8D3F6",
    fontSize: 12,
    lineHeight: 18,
    minWidth: 280,
  },

  headerBottomDeleteBtn: {
    minHeight: 42,
    paddingHorizontal: 18,
    borderRadius: 10,
    backgroundColor: "#A93442",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
  },

  headerBottomDeleteText: {
    color: "#FFFFFF",
    fontSize: 14,
    fontWeight: "700",
  },

  bottomFooterSection: {
    width: "100%",
    marginTop: 26,
    paddingBottom: 18,
  },

  bottomFooterTopLine: {
    height: 1,
    backgroundColor: "rgba(120,138,196,0.18)",
    marginBottom: 18,
  },

  bottomFooterRow: {
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 18,
    flexWrap: "wrap",
  },

  bottomFooterLeftSelect: {
    minHeight: 40,
    minWidth: 220,
    paddingHorizontal: 14,
    borderRadius: 10,
    backgroundColor: "rgba(255,255,255,0.04)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.08)",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  bottomFooterLeftSelectInner: {
    flexDirection: "row",
    alignItems: "center",
  },

  bottomFooterLeftSelectText: {
    color: "#E5ECFF",
    fontSize: 14,
    fontWeight: "500",
    marginLeft: 10,
  },

  bottomFooterCenterText: {
    flex: 1,
    color: "#C8D3F6",
    fontSize: 12,
    lineHeight: 18,
    minWidth: 280,
  },

  bottomFooterCenterTextDim: {
    color: "#A5B0D7",
  },

  bottomFooterRightGroup: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },

  bottomFooterSmallSelect: {
    minHeight: 38,
    paddingHorizontal: 14,
    borderRadius: 8,
    backgroundColor: "rgba(255,255,255,0.04)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.08)",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },

  bottomFooterSmallSelectText: {
    color: "#D7E1FF",
    fontSize: 13,
    fontWeight: "500",
  },

  bottomFooterGhostButton: {
    minHeight: 38,
    paddingHorizontal: 14,
    borderRadius: 8,
    backgroundColor: "rgba(255,255,255,0.04)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.08)",
    alignItems: "center",
    justifyContent: "center",
  },

  bottomFooterGhostButtonText: {
    color: "#D7E1FF",
    fontSize: 13,
    fontWeight: "500",
  },

  bottomFooterBottomLine: {
    height: 1,
    backgroundColor: "rgba(120,138,196,0.18)",
    marginTop: 18,
    marginBottom: 16,
  },

  bottomFooterCopyrightRow: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },

  bottomFooterCopyrightLeft: {
    color: "#7F8CB9",
    fontSize: 11,
  },

  bottomFooterCopyrightRight: {
    color: "#7F8CB9",
    fontSize: 11,
    marginLeft: "auto",
  },
});